/*
 * Populates pagetype from type if it isn't defined
 */
export default function normalizePageType (pagetype, otherMeta) {
	if (!pagetype && otherMeta.type) return otherMeta.type;
	return pagetype;
};
